import { Select } from 'antd';
import { Filter, RefreshCw } from 'lucide-react';
import type { FC } from 'react';

export interface BrickFilters {
  category?: string;
  sourceType?: string;
  persona?: string;
  isVerified?: string;
}

interface Props {
  filters: BrickFilters;
  onChange: (filters: BrickFilters) => void;
  onReset: () => void;
}

const CATEGORIES = [
  { value: 'argument_vente', label: 'Argument de vente' },
  { value: 'case_study', label: 'Case study' },
  { value: 'technical_spec', label: 'Spec technique' },
  { value: 'testimonial', label: 'Témoignage' },
  { value: 'competitive_advantage', label: 'Avantage concurrentiel' },
  { value: 'faq', label: 'FAQ' },
  { value: 'objection_response', label: 'Réponse objection' },
];

const SOURCES = [
  { value: 'markdown', label: 'Markdown' },
  { value: 'feedback', label: 'Feedback' },
  { value: 'manual', label: 'Manuel' },
];

const PERSONAS = [
  { value: 'cto', label: 'CTO' },
  { value: 'po', label: 'PO' },
  { value: 'ceo', label: 'CEO' },
  { value: 'qa-lead', label: 'QA Lead' },
];

const VERIFIED = [
  { value: '', label: 'Tous' },
  { value: 'true', label: 'Oui' },
  { value: 'false', label: 'Non' },
];

const KnowledgeBrickFilters: FC<Props> = ({ filters, onChange, onReset }) => {
  const update = (key: keyof BrickFilters, value: string | undefined) => {
    onChange({ ...filters, [key]: value || undefined });
  };

  const hasFilters = Object.values(filters).some(Boolean);

  return (
    <div className="fc-card p-4">
      <div className="flex flex-wrap items-center gap-3">
        <Filter className="w-4 h-4 text-slate-400 dark:text-slate-500 flex-shrink-0" />

        <Select
          placeholder="Catégorie"
          allowClear
          value={filters.category}
          onChange={(v) => update('category', v)}
          options={CATEGORIES}
          className="min-w-[160px]"
          popupMatchSelectWidth={false}
        />

        <Select
          placeholder="Source"
          allowClear
          value={filters.sourceType}
          onChange={(v) => update('sourceType', v)}
          options={SOURCES}
          className="min-w-[130px]"
          popupMatchSelectWidth={false}
        />

        <Select
          placeholder="Persona"
          allowClear
          value={filters.persona}
          onChange={(v) => update('persona', v)}
          options={PERSONAS}
          className="min-w-[120px]"
          popupMatchSelectWidth={false}
        />

        <Select
          placeholder="Vérifié"
          value={filters.isVerified ?? ''}
          onChange={(v) => update('isVerified', v || undefined)}
          options={VERIFIED}
          className="min-w-[110px]"
          popupMatchSelectWidth={false}
        />

        {hasFilters && (
          <button
            onClick={onReset}
            className="flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-700 dark:hover:text-slate-200 transition-colors"
          >
            <RefreshCw className="w-3.5 h-3.5" />
            Réinitialiser
          </button>
        )}
      </div>
    </div>
  );
};

export default KnowledgeBrickFilters;
